module.exports = __webpack_public_path__ + "img/swift-gls-plata-silice.b43d812c.png";